(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geethas-mobile-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('geethas-mobile-localization')) {
    customElements.define('geethas-mobile-localization', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onCountryChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onCountryChange);
      }

      onCountryChange(event) {
        if (event.target instanceof HTMLSelectElement && event.target.name === 'country_code') {
          event.target.form?.requestSubmit();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
